// src/components/TaskCard.js
import React from "react";
import "./TaskCard.scss"; // Import the SCSS file
import Iconify from "../../layouts/components/iconify/iconify";
import Avatar from "../ui/avatar/Avtar";
import { AppIcons } from "../../data/appIcons";
import Image from "../image/Image";
import { encryptUrlData } from "../../services/CryptoService";

const TaskCard = ({ task, onDelete }) => {
  
  const onEdit = () => {
    const dataURL = {};
    dataURL.taskId = task.taskId;
    dataURL.projectId = task.projectId;
    window.open(`/project/EditTask/${encryptUrlData(dataURL)}`, "_blank");
  };

  return (
    <div className="task-card">
      <div>
        <div className="card-header">
          <div className="task-id-type">
            <span className={`task-type ${task.taskTypeName.toLowerCase()}`}>
              {task.taskTypeName}
            </span>
          </div>
          <span className={`priority-badge`}>
            {task.priorityName.toLowerCase() === "high" && (
              <Image
                imgCustomClassName="priority-icon"
                imagePath={AppIcons.High}
                altText="High Priority"
              />
            )}

            {task.priorityName.toLowerCase() === "medium" && (
              <Image
                imgCustomClassName="priority-icon"
                imagePath={AppIcons.Medium}
                altText="Medium Priority"
              />
            )}

            {task.priorityName.toLowerCase() === "low" && (
              <Image
                imgCustomClassName="priority-icon"
                imagePath={AppIcons.Low}
                altText="Low Priority"
              />
            )}
          </span>
        </div>
        <div className="task-id-group">
          <span className={`task-id ${task.taskTypeName.toLowerCase()}`}>
            #{task.taskId}
          </span>
          <div className="task-title">{task.title}</div>
        </div>
      </div>
      <div className="task-info">
        <div className="small-detail">
          {/* <div className="status">
            <div className="status-text">{task.statusName}</div>
          </div> */}
          <Avatar
            src={task.assigneeAvatar} // Use a placeholder or task.assigneeAvatar if available
            alt={task.assigneeName}
            size="small"
            shape="circle"
          />
          <div className="footer-card-group">
            <Iconify icon="akar-icons:clock" className="icon" />
            <div className="time">{task.estimateHours} hrs</div>
          </div>
        </div>

        <div className="action-buttons">
          <button className="task-icon" onClick={onEdit} aria-label="Edit task">
            <Iconify icon="line-md:pencil" />
          </button>
          <button
            className="task-icon"
            onClick={onDelete}
            aria-label="Delete task"
          >
            <Iconify icon="mingcute:delete-2-line" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskCard;
